import IProject, {
  ScenarioVersion,
  SoftwareType,
  TCreateScenarioProjectPart,
} from "src/app/data/projects/interfaces/IProject";

export type ProjectUnion = IProject | TCreateScenarioProjectPart | null | undefined;

export function toggleAutoSimCheckboxVisibility(project: ProjectUnion) {
  const { scenarioVersion } = project ?? {};

  // ML3 only supports AutoSIM in the web software type; ML3Z and Mursion Meet have no
  // software type distinction, so AutoSIM is always available for them.
  if (scenarioVersion === ScenarioVersion.V3) {
    return project?.softwareType === SoftwareType.WEB;
  }

  return scenarioVersion === ScenarioVersion.V3z || scenarioVersion === ScenarioVersion.V3meet;
}

export function renderAutoSimCheckbox(project: ProjectUnion, autoSimContainer: JSX.Element) {
  return toggleAutoSimCheckboxVisibility(project) ? autoSimContainer : null;
}
